import {
  GET_SURVEY_QUESTION_TRIGGERS_FAILURE,
  GET_SURVEY_QUESTION_TRIGGERS_REQUEST,
  GET_SURVEY_QUESTIONS_FAILURE,
  GET_SURVEY_QUESTIONS_REQUEST,
  GET_SURVEY_QUESTIONS_SUCCESS,
  GET_SURVEY_QUESTION_TRIGGERS_SUCCESS,
  SET_SURVEY_LOADING_COMPLETE,
  UPDATE_SURVEY_QUESTION_SUCCESS,
  SET_QUESTION_ID,
  GET_SURVEY_QUESTION_BY_ID_SUCCESS,
  GET_SURVEY_QUESTION_BY_ID_FAILURE,
  GET_SURVEY_QUESTION_BY_ID_REQUEST,
  GET_SURVEY_QUESTION_RESPONSES_SUCCESS,
  GET_SURVEY_QUESTION_RESPONSES_REQUEST,
  GET_SURVEY_QUESTION_RESPONSES_FAILURE,
  POST_SURVEY_QUESTION_VARIATION_SUCCESS,
  UPDATE_SURVEY_QUESTION_VARIATION_SUCCESS,
  DELETE_SURVEY_QUESTION_VARIATION_SUCCESS,
  SET_SURVEY_ID
} from './surveys.types';
import produce from 'immer';

const initialState = {
  currentSurveyQuestionId: null,
  surveyQuestions: null,
  surveyQuestionTriggers: null,
  surveyQuestionVariations: null,
  isLoadingSurveyQuestions: false,
  surveyQuestionResponses: null,
  staticTriggerFields: null,
  taggedItems: null
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case GET_SURVEY_QUESTIONS_REQUEST:
    case GET_SURVEY_QUESTION_TRIGGERS_REQUEST:
    case GET_SURVEY_QUESTION_BY_ID_REQUEST:
    case GET_SURVEY_QUESTION_RESPONSES_REQUEST:
      draft.isLoadingSurveyQuestions = true;
      break;

    case SET_QUESTION_ID:
      draft.currentSurveyQuestionId = action.response;
      break;

    case SET_SURVEY_LOADING_COMPLETE:
      draft.isLoadingSurveyQuestions = false;
      break;

    case GET_SURVEY_QUESTIONS_SUCCESS:
      draft.surveyQuestions = action.response.surveyQuestions;
      draft.staticTriggerFields = action.response.staticTriggerFields
        ? action.response.staticTriggerFields.filter(stf => stf.isActive === true)
        : null;
      draft.taggedItems = action.response.surveyTaggedItems
        ? action.response.surveyTaggedItems.filter(ti => ti.isActive === true)
        : null;
      draft.surveyQuestionResponses = action.response.questionResponsess;
      draft.isLoadingSurveyQuestions = false;
      break;

    case GET_SURVEY_QUESTION_BY_ID_SUCCESS:
      draft.isLoadingSurveyQuestions = false;
      draft.surveyQuestions[draft.currentSurveyQuestionId] = action.response;
      break;

    case GET_SURVEY_QUESTION_TRIGGERS_SUCCESS:
      draft.isLoadingSurveyQuestions = false;
      draft.surveyQuestionTriggers = action.response;
      break;

    case UPDATE_SURVEY_QUESTION_SUCCESS:
      const currentSurveyQuestionIndex = draft.surveyQuestions.findIndex(
        sq => sq.surveyQuestion.surveyQuestionId === action.response.surveyQuestionId
      );
      draft.surveyQuestions[currentSurveyQuestionIndex].surveyQuestion = action.response;
      break;

    case POST_SURVEY_QUESTION_VARIATION_SUCCESS:
      const postSurveyQuestionIndex = draft.surveyQuestions.findIndex(
        sq => sq.surveyQuestion.surveyQuestionId === action.payload.surveyQuestionId
      );
      draft.surveyQuestions[postSurveyQuestionIndex].surveyQuestionVariations = action.response;
      break;

    case UPDATE_SURVEY_QUESTION_VARIATION_SUCCESS:
      const updateSurveyQuestionIndex = draft.surveyQuestions.findIndex(
        sq => sq.surveyQuestion.surveyQuestionId === action.payload.variationInfo.surveyQuestionId
      );
      draft.surveyQuestions[updateSurveyQuestionIndex].surveyQuestionVariations = action.response;
      break;

    case DELETE_SURVEY_QUESTION_VARIATION_SUCCESS:
      const deleteSurveyQuestionIndex = draft.surveyQuestions.findIndex(
        sq => sq.surveyQuestion.surveyQuestionId === action.context.surveyQuestionId
      );
      draft.surveyQuestions[deleteSurveyQuestionIndex].surveyQuestionVariations = action.response;
      break;

    case GET_SURVEY_QUESTIONS_FAILURE:
    case GET_SURVEY_QUESTION_TRIGGERS_FAILURE:
    case GET_SURVEY_QUESTION_BY_ID_FAILURE:
    case GET_SURVEY_QUESTION_RESPONSES_FAILURE:
      draft.isLoadingSurveyQuestions = false;
      break;

    case GET_SURVEY_QUESTION_RESPONSES_SUCCESS:
      draft.isLoadingSurveyQuestions = false;
      // draft.surveyQuestionResponses = action.response;
      break;

    case SET_SURVEY_ID:
      draft.surveyId = action.response;
      break;

    default:
      break;
  }

  return draft;
}, initialState);
